import {Component, OnInit} from '@angular/core';
import {OwnerService} from '../services/owner.service';
import {Router, ActivatedRoute} from '@angular/router';
import {OwnersForm} from '../models/data-model';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
declare var jQuery: any;
@Component({
    selector: 'app-detail',
    templateUrl: '../views/detail.component.html',
    styleUrls: ['../css/detail.component.css']
})
export class DetailComponent implements OnInit {
    public ownerpriority= false;
    public changedToday = false;
    //public userId = localStorage.getItem('userId');
    public userId = sessionStorage.getItem('userId');
    public ownerId: any;
    public make: string;
    public model: string;
    public countryCode: string = null;
    public countryName : string = null;
    public salesType: string = "";
    public statusCode: string = "";
    public vin: any = null;
    public purchaseDate: Date = null;
    public warrantyDate: Date = null;
    public year: number = null;
    public vehicleData: any;
    public optedIn = "No";
    public ownersForm = new OwnersForm(

        null,null, null, null, null, null, null, null, null, null, null, null, null, {}, {}, null, {}, null,
        {
            id: "",
            address1: "",
            address2: "",
            address3: "",
            address4: "",
            city: "",
            postalCode: null,
            stateId: {
                id: null,
                stateCode: null,
                name: ""
            },
            countryId: {
                id: null,
                code: null,
                name: ""
            }
        }, null, [
            {
                id: null,
                sugarVKey: null,
                individualId: null,
                vin: null,
                purchaseDate: Date,
                warrantyDate: Date,
                transactionType: "",
                cycle: {
                    id: null,
                    code: "",
                    description: "",
                    active: null
                },
                salesType: {
                    id: null,
                    code: "",
                    description: "",
                    active: null
                },
                vehicleType: {
                    id: null,
                    make: "",
                    model: ""
                },
                year: null,
                dateEntered: Date,
                createdBy: null,
                dateModified: null,
                modifiedBy: null,
                deleted: null,
                dateSynced: null
            }
        ]
    );
    public showownerLogDetails: boolean = true;
    public ownerLogDetails: any;
    public userTZ = '';
    public dealerName:string="";
    public dealerGlobalCode:string="";
    public countryNameCode : string="";
    public ownerVehicleId:string =""
    constructor(public _router: Router, public activeroute: ActivatedRoute, public _ownerService: OwnerService, public _dataService: GlobalDataService) {}

    ngOnInit() {
        window.scrollTo(0, 0);
        this.userTZ = this._dataService.USER_TZ;
        this.activeroute.params.subscribe(
            params => {
                if (Object.keys(params).length != 0) {
                    this.ownerId = params.id;
                    this.vin = params.vin;
                    this.ownerVehicleId = params.vehicleId
                    this.getOwnerDetails()
                }
            });
    }

    editOwner(ownerId,vin) {
        this._router.navigate(['owners/edit/' + ownerId+'/'+vin+ '/' +this.ownerVehicleId])
    }
    changeOwner(ownerId,vin) {
        this._router.navigate(['owners/ownerchage/'+ownerId+'/'+vin+'/' +this.ownerVehicleId])
    }
    getOwnerDetails() {

        this._ownerService.viewOwnerDetails(this.vin, this.ownerId, this.userId,this.ownerVehicleId, (result) => {
            this.ownersForm = result;
            this.vehicleData = result.vehicles;
            if(result.vehicles[0].transactionType == "OWNER"){
              let dateEntered = result.dateEntered.split("T")[0];
              let today = new Date();
              let dd = today.getDate();
              let mm = today.getMonth()+1;
              let yyyy = today.getFullYear();
              let date = yyyy+"-";
              if(mm<10){
                date+='0'+mm+"-";
              }
              if (dd<10){
                date+='0'+dd;
              }
              if(dateEntered == date){
                console.log(dateEntered);
                console.log(date);
                this.ownerpriority=false;
                this.changedToday = true;
              }else{
                console.log(dateEntered);
                console.log(date);
                this.ownerpriority=true;
              }
            }

             if(result.addressId.countryId != null){
                    this.countryCode = this.ownersForm.addressId.countryId.code;
                    this.countryName = this.ownersForm.addressId.countryId.name;
                    this.countryNameCode = this.countryName+" "+"("+this.countryCode+")";
                }
                else{
                    this.countryCode = "";
                    this.countryName = "";
                }
            if (this.vehicleData.length != 0) {

                for(let index=0; index < this.vehicleData.length; index++){
                    if(this.vehicleData[index].vin == this.vin){
                        if (result.vehicles[index].ownershipStatus != null) {
                    this.statusCode = this.vehicleData[index].ownershipStatus;
                    }
                    else {
                        this.statusCode = "";
                    }
                    if (this.vehicleData[index].salesType != null) {
                        this.salesType = this.vehicleData[index].salesType.description;
                    }
                    else {
                        this.salesType = "";
                    }
                    if (this.vehicleData[index].vehicleType != null) {
                        this.make = this.vehicleData[index].vehicleType.make;
                        this.model = this.vehicleData[index].vehicleType.model;
                    }
                    else {
                        this.make = "";
                        this.model = "";
                    }
                    if(result.optedIn)
                        this.optedIn = "Yes";

                    this.vin = this.vehicleData[index].vin;

                    this.purchaseDate = this.vehicleData[index].purchaseDate;
                    this.warrantyDate = this.vehicleData[index].warrantyDate;
                    this.year = this.vehicleData[index].year;
                    }
                }

            }
            else {
                this.make = "";
                this.model = "";
                this.salesType = "";
                this.statusCode = "";
                this.vin = null;
                this.purchaseDate = null;
                this.year = null;
                this.countryCode = "";
                this.countryName = "";
            }
            if (this.ownersForm.dealerId != null){
                this.dealerName = this.ownersForm.dealerId.name;
                this.dealerGlobalCode = this.ownersForm.dealerId.globalCode;
            }
            else{
                this.dealerName = "";
                this.dealerGlobalCode = "";
            }
        });
    }
    /**
      * @author Pradeep
      * params ownerId
      * @description get the lead log data
      */
    getOwnerLogDetails() {
        this.showownerLogDetails = true;
        this._ownerService.getOwnerLogDetails(this.ownerId, (result) => {
            this.ownerLogDetails = result;
            if (this.ownerLogDetails.length == 0)
                this.showownerLogDetails = false

        })

    }


    printOwner(printSectionId: string) {

        if(!jQuery(".collapse").hasClass('in')){
        let seeTransaction:HTMLElement = document.getElementById('seeTansactionHistory') as HTMLElement;
        seeTransaction.click();

        }
        let popupWinindow;
        let innerContents = document.getElementById(printSectionId).innerHTML;
        popupWinindow = window.open('', '_blank');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><head> <link rel="stylesheet" type="text/css" href="../../../assets/bootstrap/css/bootstrap.css"> </head><body onload="window.print()">' + innerContents + '</html>');
        popupWinindow.document.close();

    }

}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/detail.component.ts